export const VERSION_NAME_MAPPING_KEY = "versionName";
export const GSHEET_FEED_FORMAT = "gsheet";
export const FEED_TYPE = "feed";
export const CONTEXT_MAPPING_FIELD_TYPE = "field";
export const VALUE_MAPPING_VAR_TYPE = "var";

export const normalizeAutoMappings = (payloadData) => {
	const contextMappings = payloadData?._context || {};
	const autoMappings = payloadData?._mappings || {};

	const formattedMappings = Object.entries(contextMappings).map(([mappingName, mappingDetails]) => {
		return {
			name: mappingName,
			mappingElement: mappingDetails?.field,
			allowEmpty: Boolean(autoMappings[mappingName]?.allowEmpty),
		};
	});

	const hasVersionName = formattedMappings.some(mapping => mapping.name === VERSION_NAME_MAPPING_KEY);
	if (!hasVersionName) {
		formattedMappings.unshift({
			name: VERSION_NAME_MAPPING_KEY,
			mappingElement: undefined,
			allowEmpty: false,
		});
	}

	return formattedMappings.map((mapping, index) => ({
		...mapping,
		id: index + 1,
	}));
};

const toFieldValue = value => value?.value ?? value;

const getSpreadsheetId = (sourceUrl = "") => {
	const urlMatch = sourceUrl.match(/\/spreadsheets\/d\/([^/]+)/);
	return urlMatch?.[1] || sourceUrl;
};

export const getEmailAlias = (feedEmails) => {
	if (!Array.isArray(feedEmails) || feedEmails.length === 0) {
		return undefined;
	}

	const emailAliases = feedEmails
		.map(email => email?.value || email?.label || email)
		.filter(Boolean);

	if (emailAliases.length === 0) {
		return undefined;
	}

	return emailAliases.join(";");
};

const toFeedMapping = (feedMappings = []) => {
	const validMappings = feedMappings.filter(mapping => mapping?.name);
	if (validMappings.length === 0) {
		return undefined;
	}

	const contextMappings = {};
	const valueMappings = {};

	validMappings.forEach((mapping) => {
		contextMappings[mapping.name] = {
			type: CONTEXT_MAPPING_FIELD_TYPE,
			field: mapping.mappingElement,
		};
		valueMappings[mapping.name] = {
			type: VALUE_MAPPING_VAR_TYPE,
			var: mapping.name,
			allowEmpty: Boolean(mapping.allowEmpty),
		};
	});

	return {
		_type: FEED_TYPE,
		_context: contextMappings,
		_mappings: valueMappings,
	};
};

const toFeedSpecs = (sourceUrl, sourceType, sheetName) => {
	if (!sourceUrl) {
		return undefined;
	}

	const feedFormat = GSHEET_FEED_FORMAT;

	return {
		feedFormat,
		feedURL: getSpreadsheetId(sourceUrl),
		feedEncoding: "",
		feedItemKey: sheetName !== undefined && sheetName !== null ? String(sheetName) : "",
		feedAuthentication: {
			type: "",
			username: "",
			password: "",
		},
		isContentFeed: true,
	};
};

export const buildCreateContentFeedPayload = ({ formValues = {}, libraryId } = {}) => {
	const sourceUrl = formValues?.sourceUrl?.trim();
	const sourceType = toFieldValue(formValues?.sourceType);
	const sheetName = toFieldValue(formValues?.sheetName);

	const payload = {
		url: sourceUrl,
		emailAlias: getEmailAlias(formValues?.feedEmails),
		name: formValues?.feedName,
		feedMapping: toFeedMapping(formValues?.feedMappings),
		feedSpecs: toFeedSpecs(sourceUrl, sourceType, sheetName),
		autoUpdate: Boolean(formValues?.autoUpdates),
		autoMapping: Boolean(formValues?.autoMapping),
		idCreativeLibrary: Number(libraryId),
	};

	return Object.fromEntries(
		Object.entries(payload).filter(([, value]) => value !== undefined)
	);
};
